/**
 * Safely parses a date string and returns a valid Date or null.
 * Returns null if the date string is missing, empty, or invalid.
 *
 * @param dateString - The date string to parse
 * @returns A valid Date object, or null if the input is invalid
 */
export function parseDate(dateString: string | undefined | null): Date | null {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  // Check if the date is valid (Invalid Date has NaN as time value)
  if (isNaN(date.getTime())) {
    return null;
  }
  return date;
}
